import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
} from 'recharts';

/**
 * Renders a vertical bar composed of discrete stripes (like a progress bar).
 * @param {number} value        - Fraction between 0 and 1 (e.g. 0.75 for 75%).
 * @param {number} stripesCount - How many stripes to show from bottom to top.
 * @param {string} fillColor    - Color of "filled" stripes.
 * @param {string} emptyColor   - Color of "empty" stripes.
 */
const PercentageBar = ({
  value = 0.75,
  stripesCount = 20,
  fillColor = '#0088FE',
  emptyColor = '#fff',
}) => {
  // Clamp the fraction between 0 and 1
  const clampedValue = Math.max(0, Math.min(1, value));

  // Determine how many stripes are "filled"
  const fillCount = Math.round(clampedValue * stripesCount);
  console.log(fillCount);

  // Build an array of stripes; each stripe is either 1 (filled) or 0 (empty)
  const data = Array.from({ length: stripesCount }, (_, index) => ({
    stripeIndex: `${index}`,         // Y-axis label (hidden)
    fill: index < fillCount ? 1 : 0, // 1 => fillColor, 0 => emptyColor
  }));

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: emptyColor,
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '0px',
        overflow: 'hidden',
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={data}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          barCategoryGap={1} // Adjust gap between stripes if you like
        >
          <XAxis type="number" domain={[0, 1]} hide />
          <YAxis
            type="category"
            dataKey="stripeIndex"
            width={0}
            hide
            reversed // ensures the 0-based stripe is at the bottom
          />
          <Bar
            dataKey="fill"

            isAnimationActive={false}
            barSize={3} // thickness of each stripe
          >
            {data.map((entry, index) => (
              <Cell

                key={`cell-${index}`}
                fill={entry.fill === 1 ? fillColor : emptyColor}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PercentageBar;
